import Axios from 'axios'
import {visitorUrls} from '../urls'
import router from '../../../router'
import { bookingUrls } from '../../BookingService/urls'

export default {
  get_all_visitors (context) {
    Axios.get(visitorUrls.getAllVisitors).then(function (response) {
      context.commit('GET_ALL_VISITORS', response.data)
    })
  },
  get_open_visitors (context) {
    Axios.get(visitorUrls.getOpenVisitations).then(function (response) {
      context.commit('GET_OPEN_VISITORS', response.data)
    })
  },
  get_visitors (context, publicId) {
    Axios.get(visitorUrls.getVisitors + publicId).then(function (response) {
      context.commit('GET_VISITORS', response.data)
    })
  },
  get_deleted_visitors (context) {
    Axios.get(visitorUrls.getDeletedVisitor).then(function (response) {
      context.commit('GET_DELETED_VISITORS', response.data)
    })
  },
  get_visitor (context, publicId) {
    Axios.get(visitorUrls.getVisitor + publicId).then(function (response) {
      context.commit('GET_VISITOR', response.data)
    })
  },
  close_visitation (context, data) {
    Axios.patch(visitorUrls.closeVisitation, data).then(function () {
      context.dispatch('get_all_visitors')
      router.push({
        name: 'Visitors'
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  post_visitor (context, data) {
    Axios.post(visitorUrls.postVisitor, data).then(function (response) {
      window.open(response.data.url, '_blank').focus()
      context.dispatch('get_all_visitors')
      router.push({
        name: 'Visitors'
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_visitor (context, data) {
    Axios.patch(visitorUrls.editVisitor, data).then(function () {
      context.dispatch('get_all_visitors')
      router.push({
        name: 'Visitors'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_visitor (context, publicId) {
    Axios.get(visitorUrls.deleteVisitor + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_VISITORS', response.data)
      router.push({
        name: 'Module.DeletedVisitors'
      })
    })
  },
  restoreVisitor (context, publicId) {
    Axios.get(visitorUrls.restoreVisitor + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_VISITORS', response.data)
      router.push({
        name: 'Module.Visitors'
      })
    })
  },
  fetch_visitors_report (context, data) {
    Axios.post(visitorUrls.generateVisitorReport, data).then(function (response) {
      context.commit('VISITORS_REPORT', response)
    })
  },
}
